import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { SplashController } from "@karma-games/angular-devkit/src/lib/modules/splash";

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .then(async () => {
        window.document.body.classList.add("loaded");
    })
    .catch(err => {
        console.error(err);
        const splashController: SplashController = new SplashController();
        splashController.showError();
    });
